import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE;
const getToken = () => localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || '';
const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` });

const TYPE_LABELS = {
  member: '会员', ai: 'AI产品', video: '成长视频', course: '课程',
  experience: '周末活动', offline: '线下托管',
  party: '派对', creation: 'AI创作营',
  software: 'SaaS授权', promo: '线上推广', teaching: '教材',
  career: '职业探索'
}
const CATEGORY_TO_TYPE = Object.fromEntries(Object.entries(TYPE_LABELS).map(([t, c]) => [c, t]))
const CATEGORIES = ['全部', '会员', 'AI产品', '线上课', '职业探索', '派对', '成长视频', 'SaaS授权', '教材', '引流体验', '活动', 'courseware']
const COLORS = {
  '全部': '#1890ff', '会员': '#1890ff', 'AI产品': '#722ed1',
  '成长视频': '#13c2c2', '线上课': '#52c41a', '教材教具': '#fa8c16',
  'AI创作营': '#eb2f96', '职业探索': '#13c2c2', '线下次卡': '#faad14',
  '周末活动': '#52c41a', '创演托管': '#722ed1', '生日派对': '#fa8c16',
  'SaaS授权': '#1890ff', '线上推广': '#13c2c2', '线下托管': '#722ed1', '活动': '#fa8c16'
}

export default function Products() {
const safeParseArray = (str) => { try { const arr = JSON.parse(str); return Array.isArray(arr) ? arr : []; } catch (_) { return (str || '').split(',').map(s => s.trim()).filter(Boolean); } };
  const [category, setCategory] = useState('全部')
  const [search, setSearch] = useState('')
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState({ open: false, product: null })
  const [form, setForm] = useState({})
  const [qrModal, setQrModal] = useState({ open: false, product: null, loading: false, image: '' })

  useEffect(() => { fetchProducts() }, [])


  const fetchProducts = () => {
    setLoading(true)
    fetch(`${API}/products`)
      .then(r => r.json())
      .then(data => {
        if (data.success && Array.isArray(data.data) && data.data.length > 0) {
          setProducts(data.data.map(p => ({
            ...p,
            price: p.base_price || p.price || 0,
            type: p.type || (p.category?.includes('视频') ? 'video' : p.category?.includes('AI') ? 'ai' : p.category?.includes('教材') ? 'course' : p.category?.includes('派对') ? 'party' : p.category?.includes('研学') || p.category?.includes('营') ? 'camp' : p.category?.includes('会员') ? 'member' : p.category?.includes('引流') ? 'experience' : ''),
            subtitle: p.subtitle || `${p.category} · ¥${p.base_price || p.price || 0}`,
            tags: safeParseArray(p.tags),
            skills: safeParseArray(p.skills),
            themes: safeParseArray(p.themes),
            product_category: p.product_category || 'education'
          })))
        } else {
          console.error('API returned empty or error', data)
          setProducts([])
        }
      })
      .catch(err => {
        console.error('获取产品列表失败:', err)
        setProducts([])
      })
      .finally(() => setLoading(false))
  }

  const filtered = products.filter(p => {
    const matchCat = category === '全部' || p.category === category
    const matchSearch = !search || (p.name || '').includes(search) || (p.id || '').includes(search)
    return matchCat && matchSearch
  })

  const expProducts = products.filter(p => p.type === 'experience')
  const packages = {}
  expProducts.forEach(p => {
    const base = (p.name || '').replace(/·任选.*$/, '').trim() || '周末活动'
    if (!packages[base]) packages[base] = []
    packages[base].push(p)
  })

  const openNew = () => {
    setForm({ status: 'active', stock: 9999, sort: 99, category: '周末活动', type: 'experience', price: 0, original_price: 0, productId: null })
    setModal({ open: true, product: null })
  }

  const openEdit = (p) => {
    setForm({ ...p, price: p.base_price || p.price || 0, original_price: p.original_price || 0, stock: p.stock || 9999, sort: p.sort || 99, category: p.category || TYPE_LABELS[p.type] || p.type, productId: p.id })
    setModal({ open: true, product: p })
  }

  const handleSave = async () => {
    if (!form.name) { alert('请填写产品名称'); return }
    const url = modal.product ? `${API}/products/${modal.product.id}` : `${API}/products`
    const method = modal.product ? 'PUT' : 'POST'
    const productId = form.productId
    
    // 确保form中没有undefined或null，映射前端字段到后端字段
    // Map category to type
    const type = form.type || CATEGORY_TO_TYPE[form.category] || form.category || '';
    // 只发送后端需要的字段
    const cleanForm = {
      name: form.name || '',
      type: type,
      category: form.category || type || '',
      base_price: Number(form.price || form.base_price) || 0,
      original_price: Number(form.original_price) || 0,
      suitable_age_range: form.age_range || form.suitable_age_range || '',
      duration: form.duration || '',
      features: typeof form.features === 'string' ? form.features : JSON.stringify(form.features || ''),
      suitable_for: form.suitable_for || '',
      tags: Array.isArray(form.tags) ? JSON.stringify(form.tags) : (form.tags || '[]'),
      skills: Array.isArray(form.skills) ? JSON.stringify(form.skills) : (form.skills || '[]'),
      themes: Array.isArray(form.themes) ? JSON.stringify(form.themes) : (form.themes || '[]'),
      color: form.color || '#667eea',
      status: form.status || 'active',
      sync_to_growth: form.sync_to_growth ? 1 : 0,
      cover: form.cover || '',
      description: form.description || '',
      subtitle: form.subtitle || '',
    }
    
    console.log('API URL:', url)
    console.log('Method:', method)
    console.log('Form data:', cleanForm)
    try {
      const res = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cleanForm) })
      const json = await res.json()
      console.log('Response:', json)
      if (json.success) { setModal({ open: false, product: null }); fetchProducts() }
      else alert(json.error || '保存失败')
    } catch (e) { console.error('Error:', e); alert('保存失败') }
  }

  const showQRCode = async (product) => {
    setQrModal({ open: true, product, loading: true, image: '' });
    try {
      const res = await fetch(`${API}/mini/wxacode`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify({
          productId: product.id,
          width: 280
        })
      });
      const data = await res.json();
      if (data.success && data.data?.image) {
        setQrModal(q => ({ ...q, loading: false, image: data.data.image }));
      } else {
        alert('生成失败: ' + (data.error || '未知错误'));
        setQrModal(q => ({ ...q, loading: false }));
      }
    } catch (err) {
      alert('生成失败: ' + err.message);
      setQrModal(q => ({ ...q, loading: false }));
    }
  };

  const handleDelete = async (product) => {
    const id = product.id;
    const isStudyActivity = product.is_study_activity || product.type === 'study_activity';
    const msg = isStudyActivity ? `确认删除活动"${product.name}"？` : `确认删除产品"${product.name}"？`;
    if (!confirm(msg)) return
    try {
      const res = await fetch(`${API}/products/${id}`, { method: 'DELETE' })
      const json = await res.json()
      if (json.success) fetchProducts()
      else alert(json.error || '删除失败')
    } catch (e) { alert('删除失败') }
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0 }}>🎋 产品管理</h2>
          <p style={{ margin: '6px 0 0', color: '#999', fontSize: 13 }}>
            {products.length} 个产品，上架 {products.filter(p => p.status === 'active').length} 个</p>
        </div>
        <button onClick={openNew} style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>+ 新建产品</button>
      </div>

      {Object.keys(packages).length > 0 && (
        <div style={{ background: '#fff7e6', border: '1px solid #ffd591', borderRadius: 8, padding: '12px 16px', marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#ad6800' }}>🎪 周末活动套餐（三个价格对应同一活动）</div>
          {Object.entries(packages).map(([name, items]) => (
            <div key={name} style={{ display: 'flex', gap: 16, fontSize: 13 }}>
              <span style={{ color: '#666', minWidth: 100 }}>{name}</span>
              {items.sort((a, b) => (a.price || 0) - (b.price || 0)).map(item => (
                <span key={item.id} style={{ color: '#fa8c16', fontWeight: 600 }}>
                  {item.name} ¥{item.base_price || item.price}
                </span>
              ))}
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {CATEGORIES.map(cat => (
          <button key={cat} onClick={() => setCategory(cat)} style={{
            padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13,
            background: category === cat ? (COLORS[cat] || '#1890ff') : '#f5f5f5',
            color: category === cat ? '#fff' : '#666'
          }}>{cat}</button>
        ))}
      </div>

      <input type="text" placeholder="搜索产品名称或ID..." value={search}
        onChange={e => setSearch(e.target.value)} style={{
          width: '100%', maxWidth: 300, padding: '10px 14px', borderRadius: 6,
          border: '1px solid #d9d9d9', marginBottom: 20, fontSize: 14
        }} />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {filtered.map(p => (
          <div key={p.id} style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', border: '1px solid #f0f0f0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
              <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 11, background: COLORS[p.category] || '#1890ff', color: '#fff' }}>
                {p.category || TYPE_LABELS[p.type] || p.type}
              </span>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                {p.status !== 'active' && <span style={{ fontSize: 11, color: '#999', background: '#f5f5f5', padding: '2px 6px', borderRadius: 3 }}>下架</span>}
                <button onClick={() => openEdit(p)} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 12, color: '#666' }}>编辑</button>
                <button onClick={() => handleDelete(p)} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 12, color: '#ff4d4f' }}>删除</button>
              </div>
            </div>
            <h3 style={{ fontSize: 15, marginBottom: 6 }}>{p.name}</h3>
            <p style={{ fontSize: 12, color: '#666', marginBottom: 10, minHeight: 20 }}>{p.subtitle || p.description || ''}</p>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
              <span style={{ fontSize: 22, fontWeight: 700, color: '#fa8c16' }}>¥{p.base_price || p.price}</span>
              {p.original_price > p.price && p.original_price > 0 && (
                <span style={{ fontSize: 12, color: '#999', textDecoration: 'line-through' }}>¥{p.original_price}</span>
              )}
            </div>
            <div style={{ fontSize: 11, color: '#bbb', marginTop: 6 }}>ID: {p.id} | 库存: {p.stock === 9999 ? '无限' : p.stock}</div>
            <div style={{ display: 'flex', gap: 8, marginTop: 8, alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 11, color: '#999' }}>机构分成 (%)</label>
                <input type="number" min="0" max="100"
                  value={p.default_commission ?? ''}
                  onClick={e => e.stopPropagation()}
                  onChange={e => {
                    const v = e.target.value;
                    const val = v === '' ? null : parseInt(v) || 0;
                    fetch(API + '/products/' + p.id, {
                      method: 'PUT',
                      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getToken() },
                      body: JSON.stringify({ ...p, default_commission: val })
                    }).then(r => r.json()).then(json => {
                      if (json.success) { p.default_commission = val; fetchProducts(); }
                    }).catch(e => { console.error(e) });
                  }}
                  placeholder="50"
                  style={{ width: '100%', padding: '4px 6px', textAlign: 'center',
                    border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13 }} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 11, color: '#999' }}>推广佣金 (%)</label>
                <input type="number" min="0" max="100"
                  value={p.agent_commission ?? ''}
                  onClick={e => e.stopPropagation()}
                  onChange={e => {
                    const v = e.target.value;
                    const val = v === '' ? null : parseInt(v) || 0;
                    fetch(API + '/products/' + p.id, {
                      method: 'PUT',
                      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getToken() },
                      body: JSON.stringify({ ...p, agent_commission: val })
                    }).then(r => r.json()).then(json => {
                      if (json.success) { p.agent_commission = val; fetchProducts(); }
                    }).catch(e => { console.error(e) });
                  }}
                  placeholder="30"
                  style={{ width: '100%', padding: '4px 6px', textAlign: 'center',
                    border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 13 }} />
              </div>
              <button onClick={(e) => { e.stopPropagation(); showQRCode(p); }} style={{
                padding: '6px 12px', background: '#fa8c16', color: '#fff',
                border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap'
              }}>📱 生成太阳码</button>
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && !loading && (
        <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>暂无产品</div>
      )}

      {modal.open && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setModal({ open: false, product: null })}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 640, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 20px', fontSize: 18 }}>{modal.product ? '编辑产品' : '新建产品'}</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>产品名称 *</label>
                <input value={form.name || ''} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="如：周末活动·单次" style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>产品类型</label>
                <select value={form.category || '周末活动'} onChange={e => setForm(f => ({ ...f, category: e.target.value, type: CATEGORY_TO_TYPE[e.target.value] || e.target.value }))} style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}>
                  {Object.entries(TYPE_LABELS).map(([t, label]) => (<option key={t} value={label}>{label}</option>))}
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>副标题/简介</label>
              <input value={form.subtitle || ''} onChange={e => setForm(f => ({ ...f, subtitle: e.target.value }))} placeholder="简短描述" style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>售价（元）</label>
                <input type="number" value={form.price || 0} onChange={e => setForm(f => ({ ...f, price: parseFloat(e.target.value) || 0 }))} style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>原价（元）</label>
                <input type="number" value={form.original_price || ''} onChange={e => setForm(f => ({ ...f, original_price: parseFloat(e.target.value) || 0 }))} style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>库存（999=无限）</label>
                <input type="number" value={form.stock || 9999} onChange={e => setForm(f => ({ ...f, stock: parseInt(e.target.value) || 9999 }))} style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>状态</label>
                <select value={form.status || 'active'} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}>
                  <option value="active">上架</option><option value="inactive">下架</option><option value="draft">草稿</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>排序</label>
                <input type="number" value={form.sort || 99} onChange={e => setForm(f => ({ ...f, sort: parseInt(e.target.value) || 99 }))} style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>适合年龄</label>
                <input value={form.age_range || ''} onChange={e => setForm(f => ({ ...f, age_range: e.target.value }))} placeholder="如：5-12岁" style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>封面图</label>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input value={form.cover || ''} onChange={e => setForm(f => ({ ...f, cover: e.target.value }))} placeholder="https://cdn.boxiaotu.cn/images/..." style={{ flex: 1, padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
                <button type="button" onClick={async () => {
                  const input = document.createElement('input');
                  input.type = 'file';
                  input.accept = 'image/*';
                  input.onchange = async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    // 上传到服务器
                    const formData = new FormData();
                    formData.append('file', file);
                    try {
                      const res = await fetch('/cms/api/upload', { method: 'POST', body: formData });
                      const data = await res.json();
                      if (data.success) {
                        setForm(f => ({ ...f, cover: data.data.url }));
                      } else {
                        alert('上传失败: ' + (data.error || '未知错误'));
                      }
                    } catch (err) {
                      alert('上传失败: ' + err.message);
                    }
                  };
                  input.click();
                }} style={{ padding: '8px 14px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, whiteSpace: 'nowrap' }}>上传图片</button>
              </div>
              {form.cover && <img src={form.cover} alt="封面预览" style={{ marginTop: 8, maxHeight: 100, borderRadius: 6, objectFit: 'cover' }} onError={e => { e.target.style.display = 'none' }} />}
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>详细描述</label>
              <textarea value={form.description || ''} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="产品详细介绍..." rows={3} style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, resize: 'vertical' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>标签</label>
                <input value={Array.isArray(form.tags) ? form.tags.join(', ') : (form.tags || '')} onChange={e => setForm(f => ({ ...f, tags: e.target.value.split(',').map(s => s.trim()).filter(Boolean) }))} placeholder="故事,绘本,AI生成" style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>能力维度</label>
                <input value={Array.isArray(form.skills) ? form.skills.join(', ') : (form.skills || '')} onChange={e => setForm(f => ({ ...f, skills: e.target.value.split(',').map(s => s.trim()).filter(Boolean) }))} placeholder="语言表达,创造力,社会交往" style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
              <div>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 4 }}>主题</label>
                <input value={Array.isArray(form.themes) ? form.themes.join(', ') : (form.themes || '')} onChange={e => setForm(f => ({ ...f, themes: e.target.value.split(',').map(s => s.trim()).filter(Boolean) }))} placeholder="勇敢,友谊,探险" style={{ width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
              <button onClick={handleSave} style={{ flex: 1, padding: '12px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15, fontWeight: 600 }}>保存</button>
              <button onClick={() => setModal({ open: false, product: null })} style={{ flex: 1, padding: '12px', background: '#f5f5f5', color: '#666', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15 }}>取消</button>
            </div>
          </div>
        </div>
      )}

      {/* 二维码弹窗 */}
      {qrModal.open && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }} onClick={() => setQrModal({ open: false, product: null, loading: false, image: '' })}>
          <div style={{
            background: '#fff', borderRadius: 12, padding: 24, maxWidth: 360, width: '90%',
            textAlign: 'center', boxShadow: '0 8px 30px rgba(0,0,0,0.15)'
          }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 6px', fontSize: 16 }}>{qrModal.product?.name}</h3>
            <p style={{ fontSize: 12, color: '#999', margin: '0 0 16px' }}>微信扫码 → 小程序商品详情</p>
            {qrModal.loading ? (
              <div style={{ padding: '40px 0', color: '#999', fontSize: 13 }}>生成中...</div>
            ) : qrModal.image ? (
              <>
                <img src={qrModal.image} alt="太阳码" style={{ width: 220, height: 220, display: 'block', margin: '0 auto 16px', borderRadius: 8 }} />
                <p style={{ fontSize: 11, color: '#bbb', margin: '0 0 16px' }}>长按图片保存/截图转发给家长</p>
              </>
            ) : (
              <div style={{ padding: '40px 0', color: '#ff4d4f', fontSize: 13 }}>生成失败</div>
            )}
            <button onClick={() => setQrModal({ open: false, product: null, loading: false, image: '' })} style={{
              padding: '8px 32px', background: '#f5f5f5', color: '#666', border: 'none',
              borderRadius: 6, cursor: 'pointer', fontSize: 14
            }}>关闭</button>
          </div>
        </div>
      )}
    </div>
  )
}
